import React, { useEffect } from 'react';
import { FloatingParticles } from './components/FloatingParticles';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutionsSection } from './components/FailedSolutionsSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { WhoIsForSection } from './components/WhoIsForSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { WhatsAppButton } from './components/WhatsAppButton';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    document.title = 'Fin del Insomnio por Ansiedad';
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-[#0a0e27] text-slate-50 selection:bg-blue-500/30 selection:text-blue-200 relative" data-id="element-0">
      {/* Ambient Background */}
      <FloatingParticles data-id="element-1" />

      {/* WhatsApp Support Button */}
      <WhatsAppButton data-id="element-2" />

      {/* Main Content */}
      <main className="relative z-10 overflow-hidden" data-id="element-3">
        <HeroSection data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <FailedSolutionsSection data-id="element-6" />
        <MechanismSection data-id="element-7" />
        <WhatYouGetSection data-id="element-8" />
        <WhoIsForSection data-id="element-9" />
        <HowItWorksSection data-id="element-10" />
        <ProofSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <OfferSection data-id="element-13" />
      </main>

      {/* Footer */}
      <footer id="footer" className="relative z-10 py-8 text-center text-gray-500 text-sm border-t border-white/5 bg-[#0a0e27]" data-id="element-14">
        <p data-id="element-15">
          © {new Date().getFullYear()} El Fin del Insomnio por Ansiedad. Todos
          los derechos reservados.
        </p>
      </footer>
    </div>;
}